import { render, staticRenderFns } from "./SumClaimMD.vue?vue&type=template&id=ad8c7be0&scoped=true&"
import script from "./SumClaimMD.vue?vue&type=script&lang=js&"
export * from "./SumClaimMD.vue?vue&type=script&lang=js&"
import style0 from "./SumClaimMD.vue?vue&type=style&index=0&id=ad8c7be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8c7be0",
  null
  
)

export default component.exports